import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingUnexpectedError = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="243"
        height="200"
        viewBox="0 0 243 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M179.308 38.5688C192.859 57.4061 200.187 76.1861 200.752 93.9868C201.387 111.79 195.275 128.668 187.206 146.066C179.134 163.407 169.045 181.265 155.499 183.626C141.952 185.93 124.946 172.796 106.385 165.366C87.7573 157.99 67.5887 156.377 55.0131 145.261C42.4535 134.085 37.5533 113.403 40.0904 93.2385C42.6848 73.0763 52.8309 53.4222 68.3947 34.9968C84.018 16.5051 105.174 -0.77839 125.58 0.0270895C146.044 0.834858 165.817 19.7293 179.308 38.5688Z"
          fill="#F9F9F9"
        />
        <path
          d="M166.381 143.195H77.9253V153.601H166.381V143.195Z"
          fill="#B2B2B2"
        />
        <path
          d="M172.624 30.8047H92.4941V149.439H172.624V30.8047Z"
          fill="#E8F0FF"
        />
        <path
          d="M92.4944 30.8044H73.7627V149.439H92.4944V30.8044Z"
          fill="#E6E6E6"
        />
        <path
          d="M166.441 40.3716H99.2393V53.3251H166.441V40.3716Z"
          fill="#E6E6E6"
        />
        <path
          d="M161.616 47.4931C162.87 47.4931 163.887 46.4762 163.887 45.2217C163.887 43.9672 162.87 42.9502 161.616 42.9502C160.361 42.9502 159.344 43.9672 159.344 45.2217C159.344 46.4762 160.361 47.4931 161.616 47.4931Z"
          fill="#E8F0FF"
        />
        <path
          d="M122.445 45.2217H157.432"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.441 62.27H99.2393V75.2235H166.441V62.27Z"
          fill="#E6E6E6"
        />
        <path
          d="M161.616 69.3913C162.87 69.3913 163.887 68.3743 163.887 67.1198C163.887 65.8653 162.87 64.8484 161.616 64.8484C160.361 64.8484 159.344 65.8653 159.344 67.1198C159.344 68.3743 160.361 69.3913 161.616 69.3913Z"
          fill="#E8F0FF"
        />
        <path
          d="M122.445 67.1199H157.432"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.441 84.1653H99.2393V97.1188H166.441V84.1653Z"
          fill="#E6E6E6"
        />
        <path
          d="M161.616 91.2868C162.87 91.2868 163.887 90.2699 163.887 89.0154C163.887 87.7609 162.87 86.7439 161.616 86.7439C160.361 86.7439 159.344 87.7609 159.344 89.0154C159.344 90.2699 160.361 91.2868 161.616 91.2868Z"
          fill="#E8F0FF"
        />
        <path
          d="M122.445 89.0151H157.432"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.441 106.063H99.2393V119.017H166.441V106.063Z"
          fill="#E6E6E6"
        />
        <path
          d="M161.616 113.185C162.87 113.185 163.887 112.168 163.887 110.913C163.887 109.659 162.87 108.642 161.616 108.642C160.361 108.642 159.344 109.659 159.344 110.913C159.344 112.168 160.361 113.185 161.616 113.185Z"
          fill="#E8F0FF"
        />
        <path
          d="M122.445 110.913H157.432"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.441 127.958H99.2393V140.912H166.441V127.958Z"
          fill="#E6E6E6"
        />
        <path
          d="M161.616 135.083C162.87 135.083 163.887 134.066 163.887 132.811C163.887 131.557 162.87 130.54 161.616 130.54C160.361 130.54 159.344 131.557 159.344 132.811C159.344 134.066 160.361 135.083 161.616 135.083Z"
          fill="#E8F0FF"
        />
        <path
          d="M122.445 132.811H157.432"
          stroke="#E8F0FF"
          strokeWidth="1.17986"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 49.6909H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 52.3005H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 67.4424H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 70.0508H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 89.0151H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 91.6274H88.4593"
          stroke="#F2F7FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 109.888H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 112.5H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 132.788H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.3789 135.401H88.4593"
          stroke="#E8F0FF"
          strokeWidth="0.589929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.823 101.872C140.811 98.1591 140.583 88.289 147.138 86.512C151.647 85.2862 161.491 90.3251 165.716 92.44C172.637 93.1793 204.126 99.1453 228.231 103.987L228.231 138.104C203.039 129.387 177.601 117.421 167.325 112.312C160.105 111.507 146.833 109.282 142.823 101.872Z"
          fill="#FFB688"
        />
        <path
          d="M99.7006 100.847C101.713 97.1344 101.94 87.2643 95.3857 85.4873C90.8769 84.2615 81.0321 89.3004 76.807 91.4153C69.8862 92.1546 38.3971 98.1207 14.2926 102.963L14.2926 137.08C39.4847 128.362 64.9221 116.396 75.1989 111.288C82.4188 110.483 95.6901 108.257 99.7006 100.847Z"
          fill="#FFB688"
        />
        <path
          d="M91.8971 80.6786C91.0069 81.8909 90.1204 83.9645 89.6773 87.3615C89.4082 89.4244 89.8167 91.9121 90.5496 94.8112C90.9147 96.2553 91.3563 97.7877 91.8265 99.4077L91.9149 99.7125C92.3582 101.239 92.8231 102.84 93.2667 104.506C95.1597 111.612 96.6802 119.938 94.5371 128.973C91.0631 143.62 86.4755 152.82 81.2667 158.988C76.053 165.162 70.2461 168.262 64.4129 170.755C63.0524 171.336 61.6948 171.884 60.3447 172.428L60.3446 172.428C55.8878 174.224 51.5125 175.988 47.3831 178.844C42.0318 182.546 37.0989 188.091 33.103 197.941C32.7838 198.237 32.229 197.959 32.2719 197.604C36.3271 187.607 41.3646 181.917 46.8729 178.107C51.0925 175.188 55.5921 173.375 60.0673 171.571L60.0673 171.571C61.4032 171.033 62.737 170.496 64.0604 169.93C69.8358 167.462 75.4971 164.43 80.5814 158.409C85.6706 152.383 90.2107 143.328 93.6644 128.766C95.7559 119.948 94.2806 111.797 92.4 104.737C91.9592 103.082 91.4971 101.49 91.0535 99.9624L91.0534 99.9621L90.9651 99.6577C90.4955 98.0395 90.0495 96.4926 89.68 95.031C88.9438 92.1185 88.4953 89.4889 88.7879 87.2455C89.2436 83.7521 90.167 81.5193 91.1742 80.1478C92.1751 78.7846 93.2871 78.2422 94.1007 78.2422C94.3484 78.2422 94.5492 78.443 94.5492 78.6906C94.5492 78.9383 94.3484 79.1391 94.1007 79.1391C93.6662 79.1391 92.7934 79.4579 91.8971 80.6786Z"
          fill="#0B0B0B"
        />
        <path
          d="M109.706 80.0778C110.05 81.3732 109.333 82.7254 108.027 83.0276C103.623 84.0466 97.6096 84.1922 95.6488 79.7628C92.8066 73.3421 98.7728 70.0916 103.327 68.0108C104.788 67.3431 106.537 68.1697 106.95 69.7224L107.54 71.9395L108.929 77.1597L109.706 80.0778Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M114.671 69.524C114.806 69.9227 114.593 70.3555 114.194 70.4905L108.461 72.4323L109.457 76.1758L115.094 74.2662C115.492 74.1311 115.925 74.3448 116.06 74.7435C116.195 75.1423 115.982 75.575 115.583 75.7101L109.85 77.6524L110.443 79.8814C110.886 81.5448 109.973 83.3597 108.2 83.7698C105.947 84.291 103.232 84.6028 100.795 84.1895C98.3448 83.7739 96.072 82.5997 94.9526 80.0709C94.1906 78.3494 93.997 76.786 94.2605 75.3705C94.5231 73.9591 95.2275 72.7615 96.1511 71.746C97.9739 69.7418 100.74 68.3546 103.011 67.3171C104.902 66.4529 107.153 67.5174 107.688 69.5259L108.068 70.9557L113.705 69.0465C114.103 68.9115 114.536 69.1252 114.671 69.524ZM106.214 69.918C105.922 68.821 104.676 68.2324 103.644 68.7037C101.361 69.747 98.8672 71.0254 97.279 72.7718C96.4971 73.6316 95.9582 74.5805 95.7593 75.6495C95.5612 76.7143 95.6877 77.965 96.3468 79.4538C97.1881 81.3545 98.9024 82.3221 101.05 82.6863C103.211 83.0528 105.705 82.7822 107.857 82.2844C108.696 82.0903 109.217 81.2008 108.97 80.2734L106.214 69.918Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M148.148 82.2337C148.029 82.4511 148.109 82.7236 148.326 82.8422C150.031 83.7726 152.371 85.5976 153.845 88.0244C155.306 90.4307 155.91 93.4132 154.214 96.7539C153.14 98.8676 151.826 100.104 150.595 101.15C150.446 101.277 150.297 101.402 150.148 101.526C149.089 102.412 148.068 103.267 147.458 104.508C146.748 105.951 146.612 107.85 147.325 110.833C148.038 113.813 149.614 117.938 152.406 123.882C157.991 135.769 167.94 154.2 181.002 167.635C194.059 181.066 210.351 189.616 228.529 181.39C228.755 181.288 228.855 181.022 228.753 180.796C228.651 180.571 228.385 180.471 228.16 180.573C210.501 188.563 194.605 180.342 181.645 167.01C168.689 153.683 158.79 135.361 153.218 123.501C150.432 117.571 148.888 113.513 148.197 110.624C147.507 107.737 147.684 106.08 148.263 104.903C148.783 103.844 149.646 103.12 150.72 102.218C150.868 102.094 151.02 101.966 151.176 101.834C152.443 100.756 153.861 99.4283 155.013 97.1601C156.877 93.4896 156.2 90.1754 154.611 87.559C153.035 84.9631 150.56 83.0394 148.756 82.055C148.539 81.9363 148.266 82.0163 148.148 82.2337Z"
          fill="#0B0B0B"
        />
        <path
          d="M133.969 79.2987C133.26 80.4847 133.588 82.0279 134.796 82.6974C138.872 84.9552 144.79 86.8034 147.988 82.9695C152.624 77.4121 147.633 72.5004 143.71 69.1481C142.451 68.0723 140.483 68.3959 139.634 69.8175L138.421 71.8475L135.565 76.6269L133.969 79.2987Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M113.061 56.0112C113.361 55.9573 113.649 56.1572 113.702 56.4577L114.869 62.9627C114.923 63.2632 114.723 63.5504 114.422 63.6043C114.122 63.6582 113.835 63.4583 113.781 63.1578L112.614 56.6528C112.56 56.3523 112.76 56.065 113.061 56.0112Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.64 70.5893C128.664 70.8937 128.436 71.1598 128.132 71.1838L121.544 71.7026C121.239 71.7266 120.973 71.4993 120.949 71.1949C120.925 70.8906 121.152 70.6245 121.457 70.6005L128.045 70.0817C128.35 70.0577 128.616 70.285 128.64 70.5893Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.716 59.0761C124.932 59.2927 124.93 59.6427 124.714 59.8579L119.593 64.9442C119.377 65.1594 119.027 65.1582 118.811 64.9416C118.596 64.725 118.597 64.375 118.814 64.1599L123.935 59.0735C124.151 58.8584 124.501 58.8595 124.716 59.0761Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.597 80.6902C115.894 80.6221 116.191 80.8081 116.259 81.1057L117.452 86.3162C117.52 86.6138 117.334 86.9103 117.036 86.9784C116.739 87.0465 116.442 86.8605 116.374 86.5629L115.181 81.3524C115.113 81.0548 115.299 80.7583 115.597 80.6902Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.039 76.7139C120.187 76.4469 120.523 76.3503 120.79 76.4983L125.008 78.8357C125.275 78.9836 125.372 79.32 125.224 79.5871C125.076 79.8541 124.74 79.9506 124.472 79.8027L120.254 77.4653C119.987 77.3173 119.891 76.9809 120.039 76.7139Z"
          fill="#FFCA70"
        />
      </svg>
    );
  }
);
export default BillingUnexpectedError;
